// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconEllipsis = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 32C20 36.3193 17.3193 39 13 39C8.68073 39 6 36.3193 6 32C6 27.6807 8.68073 25 13 25C17.3193 25 20 27.6807 20 32ZM32 25C27.6807 25 25 27.6807 25 32C25 36.3193 27.6807 39 32 39C36.3193 39 39 36.3193 39 32C39 27.6807 36.3193 25 32 25ZM51 25C46.6807 25 44 27.6807 44 32C44 36.3193 46.6807 39 51 39C55.3193 39 58 36.3193 58 32C58 27.6807 55.3193 25 51 25Z" />
    </svg>
  );
};
